import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';

import { EmployeeService } from '../home/services/employee.service';
import { catchError, from, of } from 'rxjs';
import { TermsService } from '../home/services/terms.service';


export const EmployeeResolverService: ResolveFn<any[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return from(inject(EmployeeService).get_employee_plan()).pipe(
    catchError(error => {
      console.error(error);
      return of([]);
    })
  );
};

export const terms_conditions_user_resolver: ResolveFn<any[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return from(inject(TermsService).getTermsConditionUser()).pipe(
    catchError(error => {
      console.error(error);
      return of([]);
    })
  );
};
